import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../providers/auth.provider";
import { CONST } from "../providers/const";

@Injectable()
export class HistorialClubStaffRouteLogged implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let role = user.role;
        let jobTitle = user.jobTitle
        if (role == CONST.ROLES.club_staff && jobTitle && jobTitle.value == "Director") {
            return true;
        } else {
            this.router.navigate(['/portal/dashboard'], { replaceUrl: true });
            return false;
        }
    }
}

